import { MinusIcon, PlusIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';
import { useState } from 'react';
import type { CartItem } from 'lib/burokshop/types';
import { useCart } from './cart-context';

export function EditItemQuantityButton({
  item,
  type
}: {
  item: CartItem;
  type: 'plus' | 'minus';
}) {
  const { updateCartItem } = useCart();
  const [loading, setLoading] = useState(false);

  const handleClick = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      await updateCartItem(item.merchandise.id, type);
    } catch (error) {
      console.error('Error updating cart item:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleClick}>
      <button
        type="submit"
        disabled={loading}
        aria-label={
          type === 'plus' ? 'Increase item quantity' : 'Reduce item quantity'
        }
        className={clsx(
          'ease flex h-full min-w-[36px] max-w-[36px] flex-none items-center justify-center rounded-full p-2 transition-all duration-200 hover:border-neutral-800 hover:opacity-80',
          {
            'ml-auto': type === 'minus',
            'opacity-50': loading
          }
        )}
      >
        {type === 'plus' ? (
          <PlusIcon className="h-4 w-4 dark:text-neutral-500" />
        ) : (
          <MinusIcon className="h-4 w-4 dark:text-neutral-500" />
        )}
      </button>
    </form>
  );
}



